export const COUNTERTOP = {
    id: "0-init",
    name: "Corner Countertop",
    levels: [
        {
            tileSize: 256,
            size: 256,
            fallbackOnly: true,
        },
        {
            tileSize: 512,
            size: 512,
        },
        {
            tileSize: 512,
            size: 1024,
        },
        {
            tileSize: 512,
            size: 2048,
        },
    ],
    faceSize: 2048,
    initialViewParameters: {
        yaw: -0.07859747898442038,
        pitch: 0.22463760446288994,
        fov: 1.0000635286785202,
    },
    linkHotspots: [
        {
            class: "second-tour-starter",
            yaw: 0.29921296723266444,
            pitch: 0.47869054204630146,
            rotation: 7.853981633974483,
            target: "1-range",
        },
        {
            yaw: 0.24858382416485725,
            pitch: 0.17710806332518736,
            rotation: 7.853981633974483,
            target: "3-nook",
        },
        {
            pitch: 0.13312429709344542,
            yaw: -0.7320981746585691,
            rotation: 5.497787143782138,
            target: "5-dining",
        },
        {
            yaw: -0.2964452685215857,
            pitch: 0.06670097939581687,
            rotation: 14.137166941154074,
            target: "4-prep",
        },
        {
            pitch: 0.06500030809429269,
            yaw: -0.4422070498177959,
            rotation: 9.42477796076938,
            target: "2-island",
        },
    ],
    infoHotspots: [
        {
            class: "intro-starter",
            yaw: -0.4329964580883452,
            pitch: 0.3450258644688482,
            title: `Deluxe Multi Cooker`,
            subhead: `Deluxe Multi Cooker`,
            text: `
            <ul>
            <li><b>#100659</b></li>
            <li>
                <b>USD</b>
                $299 |
                <b>CAD</b>
                $349
            </li>
            <li>
                Includes a stainless-steel inner pot, wire rack, and silicone seal which
                are all dishwasher-safe, and a cooking guide with recipes and cooking
                charts.
            </li>
            <li>6-qt. (5.6-L) capacity; 13" x 15" x 13" (33 cm x 38 cm x 33 cm).</li>
            <li>
                Pressure Cooker, Sous Vide Cooker, Slow Cooker, Yogurt Maker, and
                Sterilizer
            </li>
            <li>
                <b>16 preprogrammed settings:</b>
                Custom, Sear, Egg, Poultry, Beef/Pork, Seafood, White Rice, Whole
                Grains, Soup, Beans, Dessert, Steam, Slow Cook, Sous Vide, Yogurt, and
                Sterilize.
            </li>
            <li>
                <b>So Easy With Sous Vide:</b>
                Make restaurant-quality steaks, fish fillets, and pork chops in the
                comfort of your home with the Sous Vide setting. You pick the
                temperature, and it cooks to the exact doneness you love, every time! No
                more undercooked centers and overcooked outsides.
            </li>
            <li>
                <b>No-Pressure Cooking:</b>
                The pressure cooker settings let you cook 70% faster than cooking on the
                oven or stovetop, saving time and energy, and retaining more nutrients.
                And if you forgot to take meat out of the freezer, no problem: It can
                even cook from frozen!
            </li>
            <li>
                <b>Low &amp; Slow Cooking:</b>
                Get that cooked-all-day flavor without using another appliance.
            </li>
            <li>
                <b>Specialty Settings:</b>
                Save money by making yogurt at home with just two ingredients and less
                than 5 minutes of hands-on time. Use the Sterilize setting to clean
                bottles and utensils. All of this without ever turning on the oven!
            </li>
            <li>
                <b>Added Features:</b>
                There's an indicator that shows at-a-glance progress of preheating,
                cooking, and warming so you always know the status of what you’re
                making. The two lid rest slots on the back allow you to securely rest
                the lid on the Deluxe Multi Cooker instead of your counter. The steam
                release button is safely positioned to keep your hands away from any
                steam and the outside of the unit stays cool even while in use.
            </li>
            <li>
                Built in carrying handles, hidden cord storage, and an on/off switch.
            </li>
            <li>
                Separate display screen lets you adjust chime volume, brightness,
                Fahrenheit or Celsius, and adjust for high-altitude cooking if needed.
            </li>
            <li>
                Also in the
                <b>Deluxe Multi Cooker Set:</b>
                Deluxe Multi Cooker, Silicone Egg Bites Mold, Large Reusable Storage
                Bag, Ceramic Pot, Glass Lid, and Chili Mix.
            </li>
            <li>
                <span class="teal-text">
                <b>Get it at a discount or for free when you host a party.</b>
                </span>
                <br />
                Ask your consultant for details.
            </li>
         </ul>
  `,
            images: [
                `<img width="640" alt="multi-cooker-01.jpeg" src="https://pamperedchef.widen.net/content/mp2jhtoadz/jpeg/multi-cooker-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-02.jpeg" src="https://pamperedchef.widen.net/content/alk6h2mrgy/jpeg/multi-cooker-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-03.jpeg" src="https://pamperedchef.widen.net/content/kcq6qjhekc/jpeg/multi-cooker-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-04.jpeg" src="https://pamperedchef.widen.net/content/271jodjuxi/jpeg/multi-cooker-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-05.jpeg" src="https://pamperedchef.widen.net/content/oisqpuhqmj/jpeg/multi-cooker-05.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-06.jpeg" src="https://pamperedchef.widen.net/content/ieczsegp9h/jpeg/multi-cooker-06.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-07.jpeg" src="https://pamperedchef.widen.net/content/2cebcow3j2/jpeg/multi-cooker-07.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="multi-cooker-08.jpeg" src="https://pamperedchef.widen.net/content/zyhxf6cdbg/jpeg/multi-cooker-08.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe loading="lazy" src="https://pamperedchef.widen.net/view/video/g02qvkpmcz/video-product-deluxe-mutli-cooker-demo-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
            recipes: [
                {
                    title: "Sous Vide Stuffed Burgers",
                    element: `<img width="150" height="150" class="recipe-preview-img-wrap" alt="recipe-post-03.jpeg" src="https://pamperedchef.widen.net/content/plp8vdzemm/jpeg/recipe-post-03.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/bfkv2kdrql/recipe-post-03`,
                },
                {
                    title: "Pressure Cooker Barbacoa Burrito Bowl With Cilantro-Lime Rice",
                    element: `<img width="150" height="150" class="recipe-preview-img-wrap" alt="recipe-post-05.jpeg" src="https://pamperedchef.widen.net/content/uszithf0vt/jpeg/recipe-post-05.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/tppmcqtkbt/recipe-post-05`,
                },
                {
                    title: "Lemon-Raspberry Cheesecake With Raspberry Whipped Cream Crust",
                    element: `<img width="150" height="150" class="recipe-preview-img-wrap" alt="recipe-post-09.jpeg" src="https://pamperedchef.widen.net/content/udr1ohnmzo/jpeg/recipe-post-09.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/7rb2xvkrfr/recipe-post-09`,
                },
            ],
        },
        {
            yaw: -0.7356201384394367,
            pitch: 0.35624665575723746,
            title: `Egg Bites Mold`,
            subhead: `Silicone Egg Bites Mold`,
            text: `
                <ul>
                    <li><b>#100662</b></li>
                    <li>
                        <b>USD</b>
                        $30 |
                        <b>CAD</b>
                        $40
                    </li>
                    <li>3-year guarantee</li>
                    <li>Dishwasher-safe | Freezer-safe</li>
                    <li>
                        Oven-safe to 450°F (230°C) and microwave-safe (the rack
                        is not microwave-safe).
                    </li>
                    <li>
                        Seven 2.5-oz. (75-mL) wells; 8" (20-cm) diameter
                        overall.
                    </li>
                    <li>
                        Includes a stainless steel rack and a lid. The lid is
                        not leakproof and cannot be used in an air fryer,
                        microwave, or oven.
                    </li>
                    <li>
                        Because it’s made of silicone, everything releases
                        easily.
                    </li>
                    <li>
                        Fill the mold with a mixture of eggs, cheese, and
                        whatever mix-ins you want for a protein-packed breakfast
                        that’s easy to take on the go.
                    </li>
                    <li>
                        The stainless-steel rack has long handles for sous-vide
                        cooking or sterilizing items in the Deluxe Multi Cooker.
                        You can also use the mold in the Deluxe Air Fryer, oven,
                        microwave, and freezer.
                    </li>
                    <li>
                        <b>Great for:</b>
                        egg bites, hot chocolate bombs, infused ice cubes, baby
                        food, appetizers, cheesecake bites, mini muffins, and
                        more fun-sized treats.
                    </li>
                    <li>
                        Also in the <b>Sous Vide Accessories Set:</b> Silicone Egg
                        Bites Mold and Large Reusable Storage Bag.
                    </li>
                    <li>
                        Also in the <b>Deluxe Multi Cooker Set:</b> Deluxe Multi
                        Cooker, Silicone Egg Bites Mold, Large Reusable Storage
                        Bag, Ceramic Pot, Glass Lid, and Chili Mix.
                    </li>
                </ul>
            `,
            images: [
                `<img width="640" alt="egg-bites-mold-01.jpeg" src="https://pamperedchef.widen.net/content/eweokweqvh/jpeg/egg-bites-mold-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="egg-bites-mold-02.jpeg" src="https://pamperedchef.widen.net/content/mcqtj4z3ge/jpeg/egg-bites-mold-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="egg-bites-mold-03.jpeg" src="https://pamperedchef.widen.net/content/1a3lz2wlwp/jpeg/egg-bites-mold-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe loading="lazy" src="https://pamperedchef.widen.net/view/video/mrvccs5qtb/video-recipe-sous-vide-egg-bites-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
        },
        {
            yaw: -0.21647777530047385,
            pitch: 0.2204998259488633,
            title: `Reusable Storage Bags`,
            subhead: `Reusable Storage Bags`,
            text: `
            <ul>
                <li>Reduce plastic waste with reusable bags</li>
                <li>2-year guarantee</li>
                <li>
                    Dishwasher-safe | BPA, Lead, PVC, and Phthalate-free
                </li>
                <li>
                    Freezer-, microwave-, and oven-safe up to 400°F (200°C)
                </li>
                <li>
                    Take meals and snacks with you on the go! Each silicone bag has
                    a clear window and a leakproof zipper so you can see and seal
                    whatever’s inside.
                </li>
                <li>
                    Label the outside with any non-toxic dry erase marker.
                </li>
                <li>These bags are perfect for sous-vide cooking.</li>
                <li><b>Reusable Storage Bag Set</b> includes a Large Reusable Storage Bag,
                    Medium Reusable Sandwich Bag, Medium Reusable Storage Bag, and
                    Small Reusable Storage Bag.
                </li>

                <br/>
                <br/>
                <span class="title">
                    Large Reusable Storage Bag
                </span>
                <li><b>#100489</b></li>
                <li><b>USD</b> $24 | <b>CAD</b> $30</li>
                <li>Holds 8 cups (1.9 L).</li>
                <li><b>Great for:</b> transporting snacks, meal prep, storing leftovers, steaming vegetables, freezing fresh
                    foods, and
                    sous-vide cooking.</li>
                <li>Also in the <b>Sous Vide Accessories Set:</b> Silicone Egg Bites Mold and Large Reusable Storage Bag.</li>
                <li>Also in the <b>Deluxe Multi Cooker Set:</b> Deluxe Multi Cooker, Silicone Egg Bites Mold, Large Reusable
                    Storage
                    Bag, Ceramic Pot, Glass Lid, and Chili Mix.</li>

                <br/>
                <span class="title">Medium Reusable Sandwich Bag</span>
                <li><b>#100690</b></li>
                <li><b>USD</b> $16 | <b>CAD</b> $22</li>
                <li>Holds 3 cups (750 mL).</li>
                <li>Has zippers on two sides of the bag.</li>
                <li><b>Great for:</b> sandwiches and easy grab-and-go snacks.</li>

                <br/>
                <span class="title">Medium Reusable Storage Bag</span>
                <li><b>#100488</b></li>
                <li><b>USD</b> $14 | <b>CAD</b> $18</li>
                <li>Holds 3 cups (750 mL).</li>
                <li>
                    <b>Great for:</b> on-the-go lunches, meal prep, storing leftovers,
                    steaming vegetables, freezing fresh foods, and sous-vide
                    cooking.
                </li>

                <br/>
                <span class="title">Small Reusable Storage Bag</span>
                <li><b>#100487</b></li>
                <li><b>USD</b> $12 | <b>CAD</b> $15</li>
                <li>Holds 1.5 cups (375 mL).</li>
                <li><b>Great for:</b> on-the-go snacks and storing leftovers.</li>
            </ul>
`,
            images: [
                `<img width="640" alt="reusable-bags-01.jpeg" src="https://pamperedchef.widen.net/content/eemgpvm2va/jpeg/reusable-bags-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="reusable-bags-02.jpeg" src="https://pamperedchef.widen.net/content/8f2bobpcol/jpeg/reusable-bags-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="reusable-bags-03.jpeg" src="https://pamperedchef.widen.net/content/sx9hmuszgc/jpeg/reusable-bags-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="reusable-bags-04.jpeg" src="https://pamperedchef.widen.net/content/9jab7efncv/jpeg/reusable-bags-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe loading="lazy" src="https://pamperedchef.widen.net/view/video/rbrej9cvr4/video-product-stop-motion-reusable-silicone-bags-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
            ],
        },
        {
            yaw: -0.638815983699299,
            pitch: 0.30595387165649335,
            class: "hidden-icon",
            singlePaneModal: true,
            title: `Golden Spoon #1`,
            text: `<img width="640" alt="spring-golden-spoon-01.jpeg" src="https://pamperedchef.widen.net/content/woxxoyxtb7/jpeg/spring-golden-spoon-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        },
        {
            singlePaneModal: true,
            video: true,
            yaw: 0.6658071321696788,
            pitch: 0.3811444940186135,
            title: `Spring 2022 New Products`,
            text: `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe loading="lazy" src="https://pamperedchef.widen.net/view/video/or8wgqbbwp/video-highlights-new-spring-products-2022-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
        },
    ],
};
